import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const NotFoundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 50vh;
  height: 100%;
  background-color: ${theme.colors.neutral[100]};
  border-radius: ${theme.shapes.borderRadius.md};
  margin: ${theme.spacing.xs} 0;
`
export const NotFoundContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.md};
  width: 100%;
`

export const WrapStatistics = styled.div`
  margin-bottom: ${theme.spacing.md};
`

export const WrapTotalizers = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xm};
`

export const TotalizerContent = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${theme.typography.sizes.sm};

  & > b {
    font-size: ${theme.typography.sizes.xs};
  }
`
